import { Clock, Mail, Phone } from 'lucide-react';
import { useBrand } from '@/lib/brand';

/**
 * How to reach the housing office. Shown on home whenever the office has set
 * at least one contact detail; the numbers stay selectable text (a tel:/mailto:
 * link is a convenience that some in-app browsers ignore).
 */
export function OfficeCard() {
  // Loaded once per visit with the brand (App); no office details, no card.
  const office = useBrand((s) => s.office);
  const brandName = useBrand((s) => s.brand?.displayName);
  if (!office || (!office.phone && !office.email && !office.hours)) return null;
  const name = brandName ?? office.name;
  return (
    <section className="mt-6 rounded-2xl border border-slate-200 bg-white p-4" aria-labelledby="office-title">
      <h2 id="office-title" className="text-[17px] font-bold text-brand-900">
        צוות הדיור{name ? ` · ${name}` : ''}
      </h2>
      <ul className="mt-2 space-y-1 text-[16px] text-slate-700">
        {office.phone && (
          <li>
            <a href={`tel:${office.phone}`} className="flex min-h-[48px] items-center gap-2">
              <Phone className="h-4 w-4 shrink-0 text-brand-500" />
              <span dir="ltr">{office.phone}</span>
            </a>
          </li>
        )}
        {office.email && (
          <li>
            <a href={`mailto:${office.email}`} className="flex min-h-[48px] items-center gap-2 break-all">
              <Mail className="h-4 w-4 shrink-0 text-brand-500" />
              <span dir="ltr">{office.email}</span>
            </a>
          </li>
        )}
        {office.hours && (
          <li className="flex min-h-[48px] items-center gap-2">
            <Clock className="h-4 w-4 shrink-0 text-brand-500" />
            <span>{office.hours}</span>
          </li>
        )}
      </ul>
    </section>
  );
}
